<template>
<div class="planedGenerationPage">
	<div class="panel bgPanel pb1x">
		<div class="title rank">
			<span v-show="stationId!=null"> {{getLanguageStr('plant399','计划发电量')}}</span>
			<span v-show="stationId==null"> {{getLanguageStr('plant400','整体计划发电量')}}</span>
		</div>
		<div class="pl1x pr1x dpIB_E vaM_E h2x_E cb">
			<div class="classGroup cb cField_E bdSub_E tra-fast_E">
				<button type="button" :class="{active:activeIndex==index}" v-for="(item,index) in timeChoose" :key="index" style="height:100%" @click="_timeChoose(index)">{{item.datepicker}}</button>
			</div>
			<div class="posR fR">
				<button id="prev" class="w2x fa fa-angle-left fs14x" type="button" @click="dateChange('perv')" :class="{disable:activeIndex ===1}"></button>
				<vue-datepicker-local v-if="activeIndex ===0" v-model="time" class="h2x" :format="timeChoose[activeIndex].format"  @input="_changePlanTime" ref="date" :disabled-date="disabledDate" style="margin-top:0;width:8em;"></vue-datepicker-local>
				<vue-datepicker-local v-else v-model="rangeDate" format="YYYY" :local="local" class="sizeS lh20" disabled style="margin-top:0;width:8em;"></vue-datepicker-local>
				<button id="next" class="w2x fa fa-angle-right fs14x" type="button" @click="dateChange('next')" :class="{disable:activeIndex ===1}"></button>
			</div>
		</div>
		<div class="posR">
			<Loading ref="LoadingForPlan"></Loading>
			<ChartColumn id="chartPlan" :data="chartData" :chartClass="chartHeight" :option="defChartMonthOption">
			</ChartColumn>
		</div>
	</div>
</div>
</template>
<script>
import {getLanguageStr} from '@/util/language'
import * as lib from '@/util/lib'
import {getMonthGenerationPlanData,getYearGenerationPlanData,getSingleMonthGenerationPlanData,getSingleYearGenerationPlanData} from '@/api/maintain/home.js'
import Loading from '@/components/common/ui/Loading'
import ChartColumn from '@/components/common/chart/ChartColumn.vue'
import NoResult from '@/components/common/ui/NoResult'
import { getLocal } from '@/util'
export default {
	name:'PlannedGeneration',
	props: {
		chartHeight:{
			type:String,
			default:'h26x'//图表高度
		},
		powerTypeList: {
			type: Array,
			default:()=> {
					 return ["PV"]
			}
		},
		stationId:{
			type:Number,
			default:null//电站ID
		}, 
		systemId:{
			type:Number,
			default:null//电站子系统ID
		},
		regions:{
			type:Object,
			default:() =>{
				return {}
			}
		}
	},
	components:{
		Loading,
		NoResult,
		ChartColumn
	},
	data () {
		return {
			local: {},
			rangeDate: [new Date(String(lib.timeFormat(new Date(),"inc","%Y")-20)),new Date(String(Number(lib.timeFormat(new Date(),"inc","%Y"))+20))],
			defChartMonthOption: {},
			loading: false,
			chartData: [],
			result: {},
			activeIndex: 0,
			time:lib.timeFormat(new Date(),"inc","%Y"),
			timeChoose: [
				{
					datepicker: getLanguageStr('cmd96', '年'),
					format: 'YYYY',
					type: 'year'
				}, {
					datepicker: getLanguageStr('cmd97', '总'),
					format: 'YYYY',
					type: 'all'
				}
				]
			}
		},
		created () {
			this._getLocal()
		},
		methods:{
			getLanguageStr,
			disabledDate(time){//[少于当前年份20年,大于当前年份20年]
				let bYear=this.time-20;
				let FYear=Number(this.time)+20;
				if(time.getFullYear()<bYear||time.getFullYear()>FYear) return true;
			},
			dateChange(str){
				if(str==='next'){
					this.time=Number(this.time)+1
				}else{
					this.time=Number(this.time)-1
				}
				this.time=String(this.time)
				this.getGenerationPlanData();
			},
			 _getLocal () {
				this.local = getLocal()
			},
			_timeChoose(index){
				this.activeIndex = index
				this.getGenerationPlanData()
			},
			_changePlanTime(){
				this.time=String(this.time.getFullYear());
				this.getGenerationPlanData();
			},
			getMonthGenerationPlanData(){
				if(this.stationId!=null){//单体电站
					if(this.activeIndex==0){
						return new Promise((resolve, reject) => {
							getSingleMonthGenerationPlanData(this.stationId,this.time).then(response => {
								resolve(response)
							}, error => {
								reject(reject)
							})
						})
					}else{//单体整体计划发电量-总
						return new Promise((resolve, reject) => {
							getSingleYearGenerationPlanData(this.stationId).then(response => {
							resolve(response)
							}, error => {
							reject(reject)
							})
						})
					}
				}else{
					if(this.activeIndex==0){
						return new Promise((resolve, reject) => {
							getMonthGenerationPlanData(this.time,{...this.regions,powerTypeList:this.powerTypeList}).then(response => {
							resolve(response)
							}, error => {
							reject(reject)
							})
						})
					}else{//整体计划发电量-总
						return new Promise((resolve, reject) => {
							getYearGenerationPlanData({...this.regions,powerTypeList:this.powerTypeList}).then(response => {
							resolve(response)
							}, error => {
							reject(reject)
							})
						})
					}
				}
			},
			getGenerationPlanData(){
				this.$refs.LoadingForPlan.show();
				var chartData=[]
				chartData.length=0
				let activeI=this.activeIndex
				this.getMonthGenerationPlanData().then(res=>{
					if(activeI==0){
						if(res.length>0){
							chartData=[{name: getLanguageStr('plant_list27', '当月发电量'),unit: 'kWh',data:new Array(12)},{name: getLanguageStr('plant401', '当月计划发电量'),unit: 'kWh',data: new Array(12)},{ name: getLanguageStr('plant404', '当月计划完成率'), unit: '%',data: new Array(12),type:'line'
							}]
							for (let attr in chartData) {    
								$.each(chartData[attr].data, (index) => {
									chartData[attr].data[index] = null
								})
							}
							let flag=false;
							for(let i=0;i<res.length;i++){
								if(res[i].planGenerationValue){
									flag=true;
									break
								}
							}
							if(!flag){
								chartData[1].visible=false
								chartData[2].visible=false
							}
							res.forEach(function (val, index) {
								chartData[0].data[parseInt(val.month)-1] = val.generationValue
								chartData[1].data[parseInt(val.month)-1] = val.planGenerationValue
								if(val.planGenerationValueRate){
									chartData[2].data[parseInt(val.month)-1] = lib.floatFix(val.planGenerationValueRate*100, 2, null, false, true)
								}else{
									chartData[2].data[parseInt(val.month)-1] = val.planGenerationValueRate
								}
							})
							
							this.defChartMonthOption = (function () { // 默认月图表参数
								let obj = { // d
									yTitle: ['kWh'],
									timeType: 'year',
									opposite: true,
									xCategories: new Array(12)
								}
								$.each(obj.xCategories, function (index) {
										obj.xCategories[index] = index + 1
								
								})
								return obj
							}())
							this.chartData=chartData
							
						}else{
							this.chartData=[];
							this.chartData.length=0
						}
					}else{
						let dateNum=0,totalChartData=[];
						let sY=[];
						if(res.length>0){
							for (let attr in res) {
								sY.push(res[attr].year)
							}
							let mini=lib.sortData(sY)[0];
							let maxn=lib.sortData(sY)[sY.length-1]
							this.rangeDate=[new Date(String(mini)),new Date(String(maxn))]
							dateNum = maxn-mini + 1 // X轴总数
							totalChartData=[{name: getLanguageStr('plant_list28','当年发电量'),unit:'kWh',data:new Array(dateNum)},
											{name: getLanguageStr('plant402','当年计划发电量'),unit:'kWh',data:new Array(dateNum)},
											{name: getLanguageStr('plant405','当年计划完成率'),unit:'%',data:new Array(dateNum), type:'line'}]
								for (let attr in totalChartData) {    
									$.each(totalChartData[attr].data, (index) => {
										totalChartData[attr].data[index] = null
									})
								}
							let flag=false;
							for(let i=0;i<res.length;i++){
								if(res[i].planGenerationValue){
									flag=true;
									break
								}
							}
							res.forEach(function (val, index) {
								totalChartData[0].data[parseInt(val.year) -  mini] = val.generationValue
								totalChartData[1].data[parseInt(val.year) - mini] = val.planGenerationValue
								if(val.planGenerationValueRate){
									totalChartData[2].data[parseInt(val.year) -  mini] = lib.floatFix(val.planGenerationValueRate*100, 2, null, false, true)
								}else{
									totalChartData[2].data[parseInt(val.year) -  mini] = val.planGenerationValueRate
								}
							})
							if(!flag){
								totalChartData[1].visible=false
								totalChartData[2].visible=false
							}
							this.defChartMonthOption = (function () { // 默认月图表参数
								let obj = { // d
									yTitle: ['kWh'],
									timeType: 'all',
									opposite: true,
									xCategories: new Array(dateNum)
								}
								$.each(obj.xCategories, function (index) {
										obj.xCategories[index] = index+Number( mini)
								})
								return obj
							}())
							this.chartData=totalChartData
						}else{
							 this.chartData=[];
							 this.chartData.length=0;
						}
					}
				})
				 this.$refs.LoadingForPlan.hide();
			}
		},
		mounted(){
			//整体计划发电量
			this.getGenerationPlanData();
		}
}
</script>
<style lang="scss" scoped>
.planedGenerationPage{
	.panel > .title{
		margin-bottom: 0;
	}
}
</style>


// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/PlannedGeneration.vue